import {formsState, formTableRow} from "../types/index"
import formTableRowData from "../data"

export const initialState:formsState = {
    loading: false,    
    error: "",
    formData: formTableRowData}



export default initialState
